import { useState } from 'react';
import copy from 'copy-to-clipboard';

const useCopyToClipboard = (
  messageSuccess = 'Dados de pagamento copiados com sucesso!',
): [string, (text: string) => void] => {
  const [copiedMessage, setCopiedMessage] = useState<string>('');

  const handleCopy = (text: string) => {
    try {
      copy(text);
      setCopiedMessage(messageSuccess);
    } catch (error) {
      console.error('Copy failed', error);
    }
  };

  return [copiedMessage, handleCopy];
};

export { useCopyToClipboard };
